// Generate UUID
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

function getId() {
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export default getId;

export function addIdToItem(item) {
    return {
        ...item,
        id: item.id ? item.id : getId(),
    };
}

export function addIdToCollectionItems([...collection]) {
    return collection.map(addIdToItem);
}
